import {ImmutableStore} from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

const defaultState = {
  build: {
    version: 'undefined'
  }
};

class ConfigStore extends ImmutableStore {
  static storeName = 'ConfigStore';

  static handlers = {
    [Actions.CONFIG__LOADED]: 'setConfig',
    [Actions.CONFIG__BUILD_DATA_RECEIVED]: 'handleBuildData'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  handleBuildData(build) {
    this.mergeState({
      build
    });
  }

  setConfig(config) {
    this.mergeState(config);
  }

  getBuildData() {
    return this.get('build').toJS();
  }
}

export default ConfigStore;



// WEBPACK FOOTER //
// ./src/stores/ConfigStore.js